<template>
<div id="providers">
  <h2>Providers</h2>

  <provider-nav></provider-nav>

  <div>
    <div
      v-for="provider in providers"
      :key="provider.id"
    >
      <router-link :to="{ name: 'provider', params: { providerId: provider.id }}">
        {{ provider.title }}
        <span
          class="badge badge-primary"
          v-if="provider.is_public"
        >
          Public
        </span>
        <span
          class="badge badge-info"
          v-if="provider.digestible"
        >
          Digestable
        </span>
      </router-link>
    </div>
  </div>

  <pagination
    :resourceUrl="this.apiUrl('/providers', true)"
    orderBy="name"
  ></pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import ProviderNav from '@/components/ProviderNav'

import ProvidersStore from '@/stores/ProvidersStore'

export default {
  data () {
    return ProvidersStore.state
  },

  components: {
    'pagination': Pagination,
    'provider-nav': ProviderNav
  },

  methods: {
    onPageSuccess (resp) {
      this.providers = this.processSuccess(resp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Providers.vue